import React from 'react';

const WhatsAppButton = () => (
  <>
    <style>{`
      .wa-btn {
        position: fixed;
        bottom: 24px;
        right: 24px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #25D366;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 20px rgba(37, 211, 102, 0.5);
        z-index: 9999;
        transition: transform 0.2s, box-shadow 0.2s;
        text-decoration: none;
      }
      .wa-btn:hover {
        transform: scale(1.1);
        box-shadow: 0 8px 28px rgba(37, 211, 102, 0.7);
      }
      .wa-btn svg {
        width: 30px;
        height: 30px;
        fill: #fff;
      }
    `}</style>
    <a
      className="wa-btn"
      href="https://wa.me/995500703003"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.163 0 0 7.163 0 16c0 2.833.738 5.494 2.031 7.8L.07 31.413a.75.75 0 0 0 .919.92l7.752-1.948A15.938 15.938 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.5a13.44 13.44 0 0 1-6.836-1.868l-.49-.296-5.07 1.274 1.302-4.938-.32-.51A13.41 13.41 0 0 1 2.5 16C2.5 8.544 8.544 2.5 16 2.5S29.5 8.544 29.5 16 23.456 29.5 16 29.5zm7.33-9.974c-.4-.2-2.37-1.168-2.737-1.302-.366-.133-.633-.2-.9.2-.267.4-1.033 1.302-1.267 1.568-.233.267-.466.3-.866.1-.4-.2-1.688-.622-3.215-1.983-1.188-1.06-1.99-2.368-2.222-2.768-.233-.4-.025-.616.175-.816.18-.18.4-.467.6-.7.2-.233.267-.4.4-.666.133-.267.067-.5-.033-.7-.1-.2-.9-2.17-1.233-2.97-.324-.78-.652-.674-.9-.686-.233-.012-.5-.015-.767-.015-.267 0-.7.1-1.067.5s-1.4 1.367-1.4 3.333 1.433 3.866 1.633 4.133c.2.267 2.82 4.307 6.833 6.037.955.412 1.7.658 2.28.843.958.305 1.83.262 2.52.159.768-.115 2.37-.969 2.703-1.905.333-.934.333-1.735.233-1.903-.1-.167-.367-.267-.767-.467z" />
      </svg>
    </a>
  </>
);

export default WhatsAppButton;
